import { render, staticRenderFns } from "./associate-batch.vue?vue&type=template&id=7fbde3a2&"
import script from "./associate-batch.vue?vue&type=script&lang=js&"
export * from "./associate-batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports